<template>
  <section id="lodge" class="lodge">
    <Hero
      :config="$props.config"
      :loc="$props.loc"
      :wknd="$props.wknd"
      :params="$props.params"
      :title="title"
      :region="$props.region"
    />
    <div class="container" v-if="$props.region === ''">
      <div class="row">
        <div class="col-1 hidden-sm"></div>
        <div class="col-10 wrap">
          <Blocks
            :title="$props.region !== '' ? 'Holiday parks in ' + location : 'Most popular holiday parks in the United Kingdom'"
            :sub="''"
            :classN="'cap'"
            :parks="$props.parks"
          />
        </div>
      </div>
    </div>
    <div class="container top" v-if="$props.region !== ''">
      <div v-for="(park, index) in allParks" class="row">
        <div class="col-1 hidden-sm"></div>
        <div class="col-10 wrap" :class="{ bd: index !== allParks.length - 1 }">
          <h2 class="title grey">{{ park.name }}</h2>
          <div class="crumb" :class="{ 'crumbs': !isEngland }">
             <h3 v-if="!isEngland" v-for="crumb in park.breadcrumbs">{{ crumb }}</h3>
             <a v-if="isEngland && index === 0" :href="goToPlace(crumb)" v-for="(crumb, index) in park.breadcrumbs">{{ crumb }} </a>
             <h3 v-if="isEngland && index > 0" v-for="(crumb, index) in park.breadcrumbs">{{ crumb }}</h3>
          </div>
          <h3 class="sub grey">{{ park.description | userFriendly }}</h3>
          <a class="link" :href="park.url">View holiday park</a>
          <carouselCard
            :park="park"
            :properties.sync="park.properties"
          />
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-1 hidden-sm"></div>
        <div class="col-10 wrap">
          <LinkList
            :links="urlLinks"
            :title="'Holiday parks in ' + location"
            :sub="''"
            :icon="false"
          />
          <LinkList
            :links="regionLinks"
            :title="'Other regions with holiday parks in ' + location"
            :sub="''"
            :icon="false"
          />
        </div>
      </div>
    </div>
    <div v-if="$props.config.html_block_1">
      <FullImage
          :image="$props.config.image_url"
          :mobileImage="$props.config.mobile_image_url"
          :heading="'Why choose a holiday park in ' + location"
      />
      <div class="container">
          <div class="row">
              <div class="col-1 hidden-sm"></div>
              <div class="col-10 wrap">
                  <div class="inner">
                      <Content
                        :htmlText="$props.config.html_block_1"
                      />
                      <ButtonCTA
                      :text="'See properties in ' + location"
                      :link="$props.searchLink"
                      :colour="'orgWire'"
                      />
                  </div>
              </div>
          </div>
      </div>
  </div>
  <div v-if="$props.config.html_block_2">
      <FullImage
          :image="$props.config.image_url"
          :mobileImage="$props.config.mobile_image_url"
          :heading="'Why choose a holiday park in ' + location"
      />
      <div class="container">
          <div class="row">
              <div class="col-1 hidden-sm"></div>
              <div class="col-10 wrap">
                  <div class="inner">
                      <Content
                        :htmlText="$props.config.html_block_2"
                      />
                      <ButtonCTA
                          :text="'See properties in ' + location"
                          :link="$props.searchLink"
                          :colour="'orgWire'"
                      />
                  </div>
              </div>
          </div>
      </div>
  </div>
  </section>
</template>

<script>
import Hero from 'comp_seo/hero.vue'
import LinkList from 'shared/linkList.vue'
import FullImage from 'shared/fullImage.vue'
import Blocks from 'comp_lodges/image_block_with_text.vue'
import carouselCard from 'comp_lodges/carousel_card.vue'
import Content from 'shared/content.vue'
import ButtonCTA from 'shared/buttonCTA.vue'

export default {
  data: function () {
      let region = this.$props.region !== "" ? this.$props.region : "United Kingdom";
      return {
          location: region,
          regionLinks: this.$props.regions,
          urlLinks: this.$props.urls,
          propIds: this.getIds(this.$props.parks),
          allParks: this.$props.parks,
          title: ['Holiday parks in ', region, ' to rent - save 60%'],
          isEngland: this.isEngland()
      }
  },
  props: {
      config: Object,
      urls: Array,
      region: String,
      regions: Array,
      parks: Array,
      wknd: String,
      searchLink: String,
      params: Array
  },
  components: {
      Hero, LinkList, FullImage, Content, Map, ButtonCTA, Blocks, carouselCard
  },
  filters: {
      userFriendly: function (value) {
          let doc = new DOMParser().parseFromString(value, 'text/html');
          return doc.body.textContent.replace(/<[^>]*>?/gm, ' ') || "";
      }
  },
  methods: {
      getRequest() {
          return {
              method: "GET",
              credentials: "include",
              headers: {
                  'X-CSRF-TOKEN': st.getCSRFToken()
              }
          };
      },
      goToPlace: function(val) {
          return "/holiday-parks/" + val.toLowerCase();
      },
      getIds(parks) {
          let ids = [];
          for (let i = 0; i < parks.length; i++) {
              let item = parks[i];
              let props = item.sample_properties;
              for (let j = 0; j < props.length; j++) {
                if (props[j] !== '') {
                    ids.push(props[j]);
                }
              }
              item.properties = [];
          }
          return ids.join(',');
      },
      getProperties() {
          let app = this;
          let baseUrl = "/properties.json?properties=" + this.propIds;
          let parks = app.$props.parks;
          fetch(baseUrl, app.getRequest())
              .then((resp) => resp.json())
              .then(function(data) {
                  if (data.length > 0) {
                      for (let i = 0; i < parks.length; i++) {
                          for (let j = 0; j < data.length; j++) {
                              if (parks[i].sample_properties.indexOf(data[j].id) > -1) {
                                  parks[i].properties.push(data[j]);
                              }
                          }
                      }
                  }
              })
      },
      isEngland() {
          let url = window.location.href;
          return url.toLowerCase().indexOf("england") > -1;
      }
  },
  mounted: function() {
      this.getProperties();
  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.sub {
  font-size: .875rem;
  font-weight: 400;
  margin: 0 0 1.25rem 0;
  max-width: 50rem;
  color: $col_darkgrey;
}

.title {
  font-size: 1.75rem;
  text-transform: inherit;
}

.wrap {
  padding: 1.25rem;
  box-sizing: border-box;
  position: relative;

  &.bd {
    margin-bottom: 1.25rem;

    &:after {
      content: "";
      background: #DBD9D9;
      height: .0625rem;
      width: calc(100% - 2.5rem);
      position: absolute;
      bottom: -1.25rem;
      left: 1.25rem;
      margin: 1.25rem 0;
    }
  }
}

.crumb {
  margin: .625rem 0;

  &:after {
    content: "";
    display: table;
    clear: both;
  }

  h3, a {
    float: left;
    margin-right: .625rem;
    text-transform: uppercase;
    color: $col_darkgrey;
    font-weight: 700;
    position: relative;
    font-size: .875rem;
    line-height: 1.25;
  }

  a:after,
  &.crumbs h3:first-of-type:after {
    content: "";
    position: absolute;
    height: 70%;
    top: 15%;
    right: -.313rem;
    background: $col_black;
    width: .0625rem;
  }
}

.link {
    text-decoration: none;
    font-size: .875rem;
    position: relative;
    color: $col_orange;
    text-transform: uppercase;
    font-weight: 700;
    margin: .313rem 0;
    display: inline-block;

    &:after {
      width: 1.25rem;
      height: 1.25rem;
      font-size: .75rem;
      color: $col_white;
      background: $col_orange;
      content: "\00276F";
      margin-left: .25rem;
      border-radius: 1.25rem;
      text-align: center;
      line-height: 1.25rem;
      display: inline-block;
      box-sizing: border-box;
    }

    &:hover {
      text-decoration: underline;
    }
}

.top {
  margin-top: 1.25rem;
}

.lodge {
  width: 100%;
  background-size: 100%;
}

@media #{$desktop} {
  .link {
    position: absolute;
    right: 1.25rem;
    top: 1.75rem;
  }
}

</style>
